import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import {
  CmsStructureModel,
  CMS_PAGE_NORMALIZER,
  ConverterService,
  HOME_PAGE_CONTEXT,
  OccCmsPageAdapter,
  OccCmsPageRequest,
  OccEndpointsService,
  PageContext,
  PageType,
  RoutingService,
  SMART_EDIT_CONTEXT,
  WindowRef
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbCmsPageAdapter extends OccCmsPageAdapter {
  constructor(
    http: HttpClient,
    occEndpoints: OccEndpointsService,
    converter: ConverterService,
    protected routingService: RoutingService,
    protected router: Router,
    protected winRef: WindowRef
  ) {
    super(http, occEndpoints, converter)
  }

  private static checkResponseForSilentRedirect(response) {
    const rule = error => {
      return (
        (error.reason === 'invalid' && error.subject === 'code') ||
        (error.reason === 'missing' && error.subject === 'salesArea')
      )
    }
    return !!response?.error?.errors?.find(rule)
  }

  private static removeCountryLanguagePatternFromContextId(url: string): string {
    if (/\/[A-Z]{2}\/[a-z]{2}\//.test(url)) {
      const stringWithoutCountryLanguagePattern = url.substring(6)
      return stringWithoutCountryLanguagePattern === '/' ? '' : stringWithoutCountryLanguagePattern
    } else if (/\/[A-Z]{2}\/[a-z]{2}/.test(url)) {
      return ''
    } else {
      return url
    }
  }

  load(pageContext: PageContext): Observable<CmsStructureModel> {
    let params = this.getPagesRequestParams(pageContext)
    const headers = new HttpHeaders().set('Content-Type', 'application/json')

    const id = EbCmsPageAdapter.removeCountryLanguagePatternFromContextId(pageContext.id)
    pageContext = { ...pageContext, id: id || HOME_PAGE_CONTEXT }
    if (id === '') {
      params = {}
      pageContext = { id: '__HOMEPAGE__', type: 'ContentPage' } as PageContext
    }

    const endpoint = pageContext.type
      ? this.occEndpoints.buildUrl('pages', { queryParams: params })
      : this.occEndpoints.buildUrl('page', {
          urlParams: { id: pageContext.id }
        })

    return this.http.get(endpoint, { headers }).pipe(
      catchError(response => {
        if (EbCmsPageAdapter.checkResponseForSilentRedirect(response)) {
          this.routingService.go('/')
        }
        return of(response)
      }),
      this.converter.pipeable(CMS_PAGE_NORMALIZER)
    )
  }

  protected getPagesRequestParams(context: PageContext): OccCmsPageRequest {
    if (context.id === HOME_PAGE_CONTEXT || context.id === SMART_EDIT_CONTEXT) {
      return {}
    }

    const httpParams: OccCmsPageRequest = {}
    if (context.type) {
      httpParams.pageType = context.type
    }
    if (context.type === PageType.CONTENT_PAGE) {
      httpParams.pageLabelOrId = EbCmsPageAdapter.removeCountryLanguagePatternFromContextId(
        context.id
      )
    } else {
      httpParams.code = context.id
    }

    return httpParams
  }
}
